import type { FC } from 'react';
import type { MainHeaderProps } from './types';
import { useColorProvider } from '@/utils/ColorProvider';
import { cls } from '@/utils/cls';
import style from './MainHeader.module.scss';
import { useState } from 'react';
import { withChildren } from '@builder.io/react';
const linkUrl = (url: string) => {
  if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'development') {
    return url;
  }
  return url.replace(/^\//, '/total-injury-help-');
};
const MainHeader: FC<MainHeaderProps> = ({
  extendStyles,
  heading,
  links,
  usePageColors = true,
  backgroundColor,
  textColor,
  children,
  mobileLogo = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  const _backgroundColor = usePageColors ? colors.primaryAccentColor : backgroundColor;
  const _textColor = usePageColors ? 'white' : textColor;
  const hasButton = !!children && !!children.length;
  return <header className={_className} style={{
    backgroundColor: _backgroundColor || '#313E64',
    color: _textColor || 'white'
  }} data-sentry-component="MainHeader" data-sentry-source-file="MainHeader.tsx">
			<div className={style.wrapper}>
				{/* Logo */}
				<a href={linkUrl('/')} aria-label="Total Injury Help Logo">
					<img className={mobileLogo ? style.logo : cls(style.logo, style.mobileHide)} src="/TotalInjuryHelp_logo.webp" alt="Total Injury Help Logo" role="img" />
				</a>

				{/* Title */}
				{heading && <div className={style.title}>{heading}</div>}

				{/* Hamburger icon - visible only on mobile */}
				<button className={style.hamburger} onClick={() => setIsOpen(!isOpen)} aria-label="Toggle navigation menu" aria-expanded={isOpen}>
					<div className={style.bar} />
					<div className={style.bar} />
					<div className={style.bar} />
				</button>

				{/* Nav links - hidden on mobile if hamburger is closed */}
				<nav className={cls(style.navLinks, isOpen && style.open)}>
					{links.map((link, index) => <a key={index} href={linkUrl(link.url)}>
							{link.label}
						</a>)}
					<div className={cls(style.button)}> {hasButton && children}</div>
				</nav>
			</div>
		</header>;
};
export default withChildren(MainHeader);